module.exports = __webpack_public_path__ + "img/Rookie-2.6f229833.gif";